export default __webpack_public_path__ + "static/media/white-right-arrow-btn.c2cb6a41.svg";